import { useContext, useEffect, useState, useMemo } from "react";
import { useAuth } from "../Hooks/useAuth";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Logo from "../assets/LOGO.png";
import LogoutIcon from '@mui/icons-material/Logout';
import KalbuPasirinkimas from "../Components/KalbuPasirinkimas";
import { useTranslation } from "react-i18next";
import { GlobalStates } from "../GlobalStates";

const Navigation = () => {
    const { t } = useTranslation();
    // Get userStatus from context, remove unused 'type'
    const { user, setUser, isLoading, userStatus } = useContext(GlobalStates);

    // Corrected logic using userStatus.admin_confirmed
    const isUserAdmin = useMemo(() => {
        const isAdmin = userStatus?.admin_confirmed === true;
        return isAdmin;
    }, [userStatus]); // Dependency updated to userStatus

    const location = useLocation();
    const navigate = useNavigate();
    const isAuthorized = useMemo(() => {
        return user !== null && !isLoading;
    }, [user, isLoading]);
    const [active, setActive] = useState('/')

    const { logout: performLogout } = useAuth();
    
    const atsijungti = async () => {
        // Naudojame standartinį atsijungimo mechanizmą visoms naršyklėms
        const { error } = await performLogout(); 
        if (!error) { 
            setUser(null); 
            navigate('/');
        } else {
            console.error("Logout failed:", error);
        }
    }

    useEffect(() => {
        setActive(window.location.pathname)
    }, [location]);

    const linkas = (x, text) => {
        const isActive = active === '/' + x || 
            (x === 'Apklausos' && active.startsWith('/Apklausos')) || 
            (x === 'Imones' && active.startsWith('/Imones'));
        return (
            <Link key={x} className={isActive ? 'active navItem' : 'navItem'} to={'/' + x}>{text}</Link>
        )
    }

    const linkaiAdmin = ['Imones', 'Rezultatai','Tendencijos','Apklausos' ];
    const linkaiAdmiText = ['Imones', 'Rezultatai', 'Tendencijos','Apklausos']; 
    
    const linkaiNeAdmin = ['ImonesApklausos','Rezultatai','Tendencijos' ];
    const linkaiNeAdminText = ['Atlikti vertinimą','Rezultatai','Balai']; 

    return (
        isAuthorized ?
            <div className="navBar">

                <a key={'Home'} className={"navLogo"} href="https://diversity.lt" target='_blank' rel="noreferrer">{<img src={Logo} alt="Logo" />}</a>
                <KalbuPasirinkimas
                    options={t('kalba')}
                    optionsText={t('kalba_text')}
                    className='kalbaNavMobile'
                />
                <div className="NavBarDesine">
                    {
                        isUserAdmin ? (

                            <nav key='navigationConainer' className="navContainer" >
                                {linkaiAdmin.map((e, i) => (linkas(e, linkaiAdmiText[i])))} </nav>
                        ) : <nav key='navigationConainer' className="navContainer" >
                            {linkaiNeAdmin.map((e, i) => (linkas(e, linkaiNeAdminText[i])))} </nav>
                    }
                    <div className="navBarDesinesDesine">
                        <KalbuPasirinkimas
                            options={t('kalba')}
                            optionsText={t('kalba_text')}
                        />

                        <button type="button" key={'atsijungti3'} className={'navItem'} onClick={atsijungti} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'inherit' }}>
                            <LogoutIcon />
                        </button>

                    </div>
                </div>


            </div > : ''

    )
}

export default Navigation